import makeStyles from '@mui/styles/makeStyles';

const transition = 'all 200ms'

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    border: '1px solid #E1E1E1',
    borderRadius: '16px',
    boxSizing: 'border-box',
    width: '36px',
    height: '20px',
    background: '#F5F6F8',
    cursor: ({ disabled }) => (disabled ? 'default' : 'pointer'),
    transition
  },

  rootChecked: {
    borderColor: theme.palette.primary.main,
    background: '#F8D8FF'
  },

  thumb: {
    position: 'absolute',
    left: '1px',
    top: '1px',
    borderRadius: '50%',
    width: '16px',
    height: '16px',
    background: '#C6C6C6',
    transition
  },

  thumbChecked: {
    left: 'calc(100% - 1px - 16px)',
    background: theme.palette.primary.main
  }
}))

export default useStyles
